module.exports = __webpack_public_path__ + "img/jiaoxue1.022b3701.png";